var map = {
	"./0.png": 600,
	"./1.png": 849,
	"./10.png": 245,
	"./11.png": 116,
	"./12.png": 231,
	"./13.png": 38,
	"./14.png": 457,
	"./2.png": 762,
	"./3.png": 891,
	"./4.png": 599,
	"./5.png": 13,
	"./6.png": 425,
	"./7.png": 471,
	"./8.png": 520,
	"./9.png": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;